<div class="header-bar">
  <h1>Invoices</h1>
</div>

<div class="content-container" style="position: relative" *ngIf="!xeroTokenRecordFound">
  <div class="card card-w-title">
    <div>
      <div class="mb-4">
        <div class="error-1 error mb-2">IMPORTANT: No Xero OAUTH Token has been set.</div>
        <div class="error-2 error">
          Go to System Admin / System Configuration / Xero to fetch an OAUTH token before
          continuing.
        </div>
      </div>
    </div>
  </div>
</div>

<p-tabView class="tab-padding">
  <p-tabPanel header="Customer">
    <h2 class="sub-header-bar">Customer Invoices</h2>
    <customers-invoices-grid [manageMode]="2"></customers-invoices-grid>
  </p-tabPanel>

  <p-tabPanel header="Supplier">
    <ng-template pTemplate="content">
      <suppliers-batches #gridBatches (onGridAction)="onGridAction($event)"> </suppliers-batches>
    </ng-template>
  </p-tabPanel>

  <p-tabPanel header="Supplier - Failed Payments">
    <ng-template pTemplate="content">
      <suppliers-invoices-grid
        #gridFailed
        [processingStatus]="2"
        title="Supplier Invoices - Failed Payments"
        [showFilterPane]="true"
        [manageMode]="2"
        (onGridAction)="onGridAction($event)"
        [invoiceSuppliers]="invoiceSuppliers"
      >
      </suppliers-invoices-grid>
    </ng-template>
  </p-tabPanel>

  <p-tabPanel header="Supplier - Cancelled Invoices">
    <ng-template pTemplate="content">
      <suppliers-invoices-grid
        #gridCancelled
        [processingStatus]="3"
        title="Supplier - Cancelled Invoices"
        [showFilterPane]="true"
        [manageMode]="2"
        (onGridAction)="onGridAction($event)"
        [invoiceSuppliers]="invoiceSuppliers"
      >
      </suppliers-invoices-grid>
    </ng-template>
  </p-tabPanel>
  <p-tabPanel header="Unbatched Invoice">
    <ng-template pTemplate="content">
      <suppliers-invoices-grid
        #gridUnbatchedInvoice
        [processingStatus]="5"
        title="Invoices waiting to be batched"
        [showReportButton]="true"
        [showFilterPane]="true"
        [manageMode]="2"
        (onGridAction)="onGridAction($event)"
        [invoiceSuppliers]="invoiceSuppliers"
      >
      </suppliers-invoices-grid>
    </ng-template>
  </p-tabPanel>
  <p-tabPanel header="Supplier Invoices">
    <ng-template pTemplate="content">
      <suppliers-invoices-grid
        #gridInvoices
        [processingStatus]="4"
        title="Supplier Invoices"
        [showFilterPane]="true"
        [manageMode]="2"
        (onGridAction)="onGridAction($event)"
        [invoiceSuppliers]="invoiceSuppliers"
      >
      </suppliers-invoices-grid>
    </ng-template>
  </p-tabPanel>
  <p-tabPanel header="Supplier Adhoc Invoices">
    <ng-template pTemplate="content">
      <app-supplier-adhoc-invoice
        #gridSupplierAdhocInvoices
        title="Supplier Adhoc Invoices"
        [showFilterPane]="true"
        [manageMode]="2"
        (onGridAction)="onGridAction($event)"
        [invoiceSuppliers]="invoiceSuppliers"
      >
      </app-supplier-adhoc-invoice>
    </ng-template>
  </p-tabPanel>
  <p-tabPanel header="Non-Movement Transactions" *ngIf="isFinanceUser">
    <ng-template pTemplate="content">
      <app-create-non-movement-transactions
        #gridNonMovementTransaction
        title="Create Non-Movement Transactions"
        [manageMode]="2"
        (onGridAction)="onGridAction($event)"
      >
      </app-create-non-movement-transactions>
    </ng-template>
  </p-tabPanel>
</p-tabView>
